import type { ReactNode } from 'react';
import React, { useCallback, useMemo, useRef } from 'react';
import type { Theme } from 'baseui';
import { Panel } from 'baseui/accordion';
import { ToggleContainer } from './toggle-container.react';
const CONTENT_STYLE = {
  style: {
    paddingTop: '0',
    paddingRight: '0',
    paddingBottom: '0',
    paddingLeft: '0',
    outline: '0'
  }
};
const PANEL_CONTAINER_STYLE = {
  style: ({
    $theme
  }) => ({
    paddingBottom: $theme.sizing.scale300,
    paddingTop: $theme.sizing.scale300
  })
};
const HEADER_STYLE = {
  style: ({
    $theme
  }: {
    $theme: Theme;
  }) => ({
    backgroundColor: $theme.colors.backgroundPrimary,
    fontSize: $theme.sizing.scale600,
    fontWeight: '500',
    lineHeight: $theme.sizing.scale800,
    color: $theme.colors.contentPrimary,
    outline: '0',
    padding: `${$theme.sizing.scale100} ${$theme.sizing.scale600}`
  })
};
const TOGGLE_ICON_STYLE = {
  style: ({
    $theme: {
      colors
    }
  }) => ({
    color: colors.contentPrimary
  })
};
type Props = {
  title: string; // @ts-expect-error todo(ts-migration) TS2694 Namespace 'React' has no exported member 'DOM'.
  children: React.DOM;
  setInitiallyExpanded?: boolean;
  trailingComponent?: ReactNode;
};
export const CollapsiblePanel = ({
  title,
  children,
  setInitiallyExpanded,
  trailingComponent
}: Props) => {
  const [expanded, setExpanded] = React.useState(setInitiallyExpanded !== undefined ? setInitiallyExpanded : true);
  const propsRef = useRef({
    expanded,
    trailingComponent
  });
  // eslint-disable-next-line react-hooks/refs
  propsRef.current = {
    expanded,
    trailingComponent
  };
  const StableToggleIcon = useMemo(() => function ToggleIcon() {
    return <ToggleContainer expanded={propsRef.current.expanded} trailingComponent={propsRef.current.trailingComponent} />;
  }, []);
  const panelOverrides = useMemo(() => ({
    ToggleIcon: {
      component: StableToggleIcon,
      ...TOGGLE_ICON_STYLE
    },
    Content: CONTENT_STYLE,
    PanelContainer: PANEL_CONTAINER_STYLE,
    Header: HEADER_STYLE
  }), [StableToggleIcon]);
  const handleClick = useCallback(() => setExpanded(prev => !prev), []);
  return <Panel title={title} onClick={handleClick} expanded={expanded} overrides={panelOverrides}>
      {children}
    </Panel>;
};
CollapsiblePanel.defaultProps = {
  title: ''
};